import type { HttpClient } from '../client';

/** 业务键（对应后端 Hq:WeChat:SubscribeTemplates 的键）。 */
export type WxSubscribeKey =
  | 'APPROVAL_TODO'
  | 'DELIVERY_ARRIVE'
  | 'STOCK_ALERT'
  | 'RETURN_RESULT'
  | string;

export interface WxSubscribeSendRequest {
  templateKey: WxSubscribeKey;
  /** 接收用户；缺省当前登录用户（给他人推送需 sys:notify:send）。 */
  userId?: string;
  /** 模板字段（键 → 值），微信侧限制单值 ≤ 20 字符，超出由后端截断。 */
  data?: Record<string, string>;
  /** 点击消息进入的小程序页面，如 `pages/approval/index`。 */
  page?: string;
  state?: 'formal' | 'trial' | 'developer';
}

export interface WxSubscribeSendResult {
  sent: boolean;
  userId: string;
  templateKey: string;
  templateId: string;
  openidMask: string | null;
  /** 43101（用户取消授权）等预期场景会返回 sent=false + errMsg，不抛错。 */
  errMsg: string | null;
  sentAt: string;
}

export interface WxTemplateItem {
  key: string;
  templateId: string;
  configured: boolean;
}

export interface WxTemplateListResult {
  weChatReady: boolean;
  templates: WxTemplateItem[];
}

/**
 * 微信订阅消息：待办催办 / 配送到达 / 库存预警 / 退换货结果。
 * 一次性订阅语义——用户每授权一次只能推一条，因此由前端在业务动作后即时调用。
 * 微信凭据或模板未配置时后端返回 42200（不静默降级），前端应据此隐藏推送入口。
 */
export function createWxSubscribeApi(http: HttpClient) {
  return {
    /** 已配置模板清单（前端据此决定是否弹订阅授权）。 */
    templates(): Promise<WxTemplateListResult> {
      return http.request<WxTemplateListResult>({ path: '/wx/subscribe/templates' });
    },

    send(body: WxSubscribeSendRequest): Promise<WxSubscribeSendResult> {
      return http.request<WxSubscribeSendResult>({ path: '/wx/subscribe/send', method: 'POST', body });
    }
  };
}

export type WxSubscribeApi = ReturnType<typeof createWxSubscribeApi>;
